import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import RadioGroup from '@material-ui/core/RadioGroup'
import Radio from '@material-ui/core/Radio'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import ExpandablePanel from '../../components/controls/ExpandablePanel'
import { controlHasError } from '../../lib/errorHandler'
import AnimateHeight from 'react-animate-height'
import PrintText from '../../lib/PrintText'

class PolaczenieSpolek extends React.Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
  }

  render() {
    return (
      <ExpandablePanel title="POŁĄCZENIE SPÓŁEK">
        <form autoComplete="off" className="polaczenie" ref={this.myRef}>
          <FormControlLabel
            className="checkboxLabel high-caption"
            control={
              <Checkbox
                name="CzyPolaczonoSpolki"
                color="primary"
                defaultChecked={this.props.data.CzyPolaczonoSpolki}
                onChange={(e) =>
                  this.props.onSetSectionData(
                    'CzyPolaczonoSpolki',
                    e.target.checked,
                  )
                }
              />
            }
            label="W okresie sprawozdawczym nastąpiło połączenie spółek"
          />

          <AnimateHeight
            duration={250}
            height={this.props.data.CzyPolaczonoSpolki ? 'auto' : 0}
            onAnimationEnd={() => this.myRef.current.scrollIntoView()}
          >
            <RadioGroup
              row
              className="radioGroup"
              name="SporzadzonoPoPolaczeniu"
              value={this.props.data.SporzadzonoPoPolaczeniu ? 'true' : 'false'}
              onChange={(e) =>
                this.props.onSetSectionData(
                  'SporzadzonoPoPolaczeniu',
                  e.target.value === 'true',
                )
              }
            >
              <FormControlLabel
                value="true"
                control={<Radio color="primary" />}
                label="Sprawozdanie sporządzono PO połączeniu"
              />
              <FormControlLabel
                value="false"
                control={<Radio color="primary" />}
                label="Sprawozdanie sporządzono PRZED połączeniem"
              />
            </RadioGroup>
            {!this.props.czyPodsumowanie && (
              <TextField
                className="textArea"
                error={controlHasError(this.props.errors, 'OpisMetody')}
                name="OpisMetody"
                label="Zastosowana metoda rozliczenia połączenia"
                multiline
                variant="outlined"
                title={this.props.data.OpisMetody}
                defaultValue={this.props.data.OpisMetody}
                onBlur={(e) =>
                  this.props.onSetSectionData('OpisMetody', e.target.value)
                }
              />
            )}
          </AnimateHeight>
          {this.props.czyPodsumowanie && this.props.data.CzyPolaczonoSpolki && (
            <PrintText
              text={this.props.data.OpisMetody}
            />
          )}
        </form>
      </ExpandablePanel>
    )
  }
}

export default PolaczenieSpolek
